import { format, parse, parseISO } from 'date-fns'

export const formatPrintEventDate = (
  dateValue: string,
  isTBD: boolean,
  dateFormat: string = 'MMM d, yyyy',
) => {
  let date = null
  if (!dateValue || isTBD) {
    return 'TBD'
  }
  if (dateValue) {
    date = parseISO(dateValue)
  }
  return date ? format(date, dateFormat) : ''
}

export const formatEventTime = (dateValue: string, isTBD: boolean = false) => {
  if (!dateValue || isTBD) {
    return 'TBD'
  }
  if (!dateValue) {
    return 'Unknown Time'
  }

  return format(parse(dateValue, 'HH:mm:ss', new Date()), 'h:mm aaa')
}
